import { ConversationStarterPayload } from 'pages/SettingsConversationStartersPage/types';

import {
  getRequest,
  postRequest,
  patchRequest,
  deleteRequest,
} from '../../methods';

const settingsGetConversationStarters = () =>
  getRequest('settings/conversation_starters');

const settingsGetConversationStarter = (id: number) =>
  getRequest(`settings/conversation_starters/${id}`);

const settingsCreateConversationStarter = (
  payload: ConversationStarterPayload
) => postRequest('settings/conversation_starters', payload);

const settingsUpdateConversationStarter = (
  id: number,
  payload: ConversationStarterPayload
) => patchRequest(`settings/conversation_starters/${id}`, payload);

const settingsDeleteConversationStarter = (id: number) =>
  deleteRequest(`settings/conversation_starters/${id}`);

const conversationStarters = {
  settingsGetConversationStarters,
  settingsGetConversationStarter,
  settingsCreateConversationStarter,
  settingsUpdateConversationStarter,
  settingsDeleteConversationStarter,
};

export default conversationStarters;
